import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import environment from "environments/environment.js"

const mutation = graphql`
    mutation scheduleEventMutation($input: scheduleInviteHyeventInput!){
        scheduleInviteHyevent(input:$input) {
          clientMutationId
          hyevent{
            additionalGuestAllowed
            id
            publishAt
            campaignTested
            status
            title
          }
        }
    }
`;

function commit(input) {
  return new Promise((res, rej) => {
    commitMutation(environment, {
      mutation,
      variables: { input },
      onCompleted: res,
      onError: rej
    })
  });
}

export default commit;